module.exports = __webpack_public_path__ + "static/media/YF72_1.74ad7009.jpg";